module.exports = __webpack_public_path__ + "img/desktop2.3f056eb7.svg";